import { CLEAR_PAYMENT_HISTORY, GET_PAYMENT_ERROR, GET_PAYMENT_REQUEST, GET_PAYMENT_SUCCESS } from '../Types';

const initialState = {
  isSuccess: false,
  orders: [],
  nextBillInfo: null,
  activeBillInfo: null,
  hasPayments: false,
};

export const payments = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_REQUEST:
      return {
        ...state,
        isSuccess: false,
        orders: [],
        nextBillInfo: null,
        activeBillInfo: null,
        hasPayments: false,
      };
    case GET_PAYMENT_SUCCESS:
      return {
        ...state,
        isSuccess: true,
        orders: action.orders,
        nextBillInfo: action.nextBillInfo,
        activeBillInfo: action.activeBillInfo,
        hasPayments: action.orders.length > 0,
      };
    case GET_PAYMENT_ERROR:
      return {
        ...state,
        isSuccess: false,
        orders: [],
        nextBillInfo: null,
        activeBillInfo: null,
        error: action.payload,
        hasPayments: false,
      };
    case CLEAR_PAYMENT_HISTORY:
      return {
        ...state,
        isSuccess: false,
        orders: [],
        nextBillInfo: null,
        activeBillInfo: null,
        hasPayments: false,
      };
    default:
      return state;
  }
};
